import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Workshop2 from "./Testimonial2";



import testimonial1 from "../../Assets/syepMain.png";
import testimonial2 from "../../Assets/gradSYEP.png";
import testimonial3 from "../../Assets/syep_2025.jpeg";
import testimonial4 from "../../Assets/Choicest_Fruit.png";




// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";




const sliderImages = [
  { src: testimonial1, alt: "testimonials" },
  { src: testimonial2, alt: "testimonials" },
  { src: testimonial3, alt: "testimonials" },
  { src: testimonial4, alt: "testimonials" },




  // Add more images as needed

  ];
console.log(sliderImages)


function Testimonial() {
 



  // Settings for the Slick slider
  const settings = {
    dots: true, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time between slides in ms
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid"
                    style={{ objectFit: "cover", height: "60%", width: "100%" }}
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>
      
   
         
      
          <Workshop2 />

        

                                        
          
             

          
           
    </section>
  );
}

export default Testimonial;
